import { Fragment } from "react";
import { Link } from "react-router-dom";

export const ChatText = ({ text, onNavigate }) => (
  <>
    {text.replace(/\*\*/g, "").split(/(\[\[[a-f0-9]{24}\]\])/g).map((part, i) => {
      const m = part.match(/^\[\[([a-f0-9]{24})\]\]$/);
      if (!m) return <Fragment key={i}>{part}</Fragment>;
      return (
        <Link key={i} to={`/product/${m[1]}`} onClick={onNavigate} data-testid={`chat-product-link-${m[1]}`}
          className="inline-block mx-1 px-1.5 py-0.5 bg-[#FF3B30] hover:bg-[#E02E24] text-white font-mono text-[10px] uppercase tracking-wider align-middle">
          View
        </Link>
      );
    })}
  </>
);
